import { MixpanelEvents, trackEvent } from "./track";
import type { T_AnalyticsProperties } from "./types";

export type T_BrokerageConnectAnalyticsContext = {
  surface?: string;
  provider?: string | null;
  provider_name?: string | null;
  source_section?: string | null;
  is_featured?: boolean;
  brokerage_rank?: number | null;
  brokerage_count?: number | null;
  featured_count?: number | null;
  result_count?: number | null;
  connection_type?: string;
};

const BROKERAGE_CONNECT_FUNNEL = "brokerage_connect";
const DEFAULT_BROKERAGE_CONNECT_SURFACE = "web_unknown";
const BROKERAGE_CONNECT_CONNECTION_TYPE = "read";

function getBrokerageConnectAnalyticsProperties(
  context?: T_BrokerageConnectAnalyticsContext,
  extra?: T_AnalyticsProperties,
): T_AnalyticsProperties {
  return {
    feature_funnel: BROKERAGE_CONNECT_FUNNEL,
    surface: context?.surface ?? DEFAULT_BROKERAGE_CONNECT_SURFACE,
    provider: context?.provider ?? undefined,
    provider_name: context?.provider_name ?? undefined,
    source_section: context?.source_section ?? undefined,
    is_featured: context?.is_featured,
    brokerage_rank: context?.brokerage_rank ?? undefined,
    brokerage_count: context?.brokerage_count ?? undefined,
    featured_count: context?.featured_count ?? undefined,
    result_count: context?.result_count ?? undefined,
    connection_type:
      context?.connection_type ?? BROKERAGE_CONNECT_CONNECTION_TYPE,
    ...extra,
  };
}

export function trackBrokerageConnectFunnelEvent(
  name: string,
  context?: T_BrokerageConnectAnalyticsContext,
  extra?: T_AnalyticsProperties,
): void {
  trackEvent(name, getBrokerageConnectAnalyticsProperties(context, extra));
}

export function trackBrokerageConnected(
  context?: T_BrokerageConnectAnalyticsContext,
  extra?: T_AnalyticsProperties,
): void {
  trackBrokerageConnectFunnelEvent(
    MixpanelEvents.BROKERAGE_CONNECTED,
    context,
    extra,
  );
}
